import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownPosition, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckIsAdmin, ApiCreateVehicleBrand, ApiCreateVehicleColor, ApiDeleteUser, ApiDeleteUserCompany, ApiGetCompanyAccessDropdown, ApiGetUserById, ApiGetUserCompanyList, ApiInsertUserCompany, ApiRegister, ApiUpdateUser } from "utils/constants/api";
import Dropdown from "components/Input/Dropdown";
import AddButton from "components/Button/AddButton";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import TrashIcon from "assets/icon/TrashIcon";

export default function VehicleColorForm(){
    let navigate = useNavigate()

    const { fetch: registerUser } = useFetch(ApiRegister)
    const { fetch: updateUser } = useFetch(ApiUpdateUser)
    const { fetch: getUserById } = useFetch(ApiGetUserById)
    const { fetch: deleteUser } = useFetch(ApiDeleteUser)
    const { fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)

    const { fetch: createVehicleColor } = useFetch(ApiCreateVehicleColor)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramVehicleColorId = queryString.get("vehicleColorId")
    let paramUserId = queryString.get("userId")
    
    const [vehicleBrandName, setVehicleBrandName] = useState(EmptyString)
    const vehicleBrandNameChange = (e) => {
        setVehicleBrandName(e.target.value)
    }
    const [errVehicleBrandName, setErrVehicleBrandName] = useState(false)

    const [vehicleColorName, setVehicleColorName] = useState(EmptyString)
    const vehicleColorNameChange = (e) => {
        setVehicleColorName(e.target.value)
    }
    const [errVehicleColorName, setErrVehicleColorName] = useState(false)

    const [userId, setUserId] = useState(EmptyString)
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [email, setEmail] = useState(EmptyString)    
    const [password, setPassword] = useState(EmptyString)
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [division, setDivision] = useState(DropdownPosition[0].value)
    const [isAdmin, setIsAdmin] = useState(false)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const saveBtnClick = () => {
        if(fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fInsertVehicleColor().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateUser().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})
            
            let stat

            if (status === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeleteUser(paramUserId, stat).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    useEffect(() => {
        setLoading({isOpen: true})
        if (formType === FormTypeEdit){
            setLoading({isOpen: true})

            fGetUserById(paramUserId).then(() => {
                // fGetCompany().then(() => {
                //     fGetUserCompanyList().then(() => {
                //         setLoading({isOpen: false})
                //     })                    
                // })     
                setLoading({isOpen: false})           
            })
        }else{
            setLoading({isOpen: false})
        }
    }, [])

    // Function Api Call
    async function fInsertVehicleColor(){
        await createVehicleColor({
            data: {
                vehicleColor: vehicleColorName
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/vehicle-color") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    async function fInsertUser(){
        await registerUser({
            data: {
                username: username,
                fullName: name,
                divisionId: division,
                password: password,
                isAdmin: isAdmin
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/user") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateUser(){
        await updateUser({
            data: {
                userId: paramUserId,
                username: username,
                fullName: name,
                divisionId: division,
                password: password,
                isAdmin: isAdmin
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/user") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteUser(id, status){
        await deleteUser({
            data: {
                userId: id,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/user-setting")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetUserById(paramUserId){
        await getUserById({
            data: {
                userId: paramUserId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                setUserId(data.userId)
                setUsername(data.username)
                setName(data.fullName)
                setIsAdmin(data.isAdmin)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (vehicleColorName === EmptyString || vehicleColorName === null){
            setErrVehicleColorName(true)
            errorCount++
        }else{
            setErrVehicleColorName(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }

    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Vehicle Color Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Vehicle Color */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Vehicle Color</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={vehicleColorName} onChange={vehicleColorNameChange} maxLength={20} disabled={formType === FormTypeEdit ? true : false} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errVehicleColorName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Color Name is required!</span>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            
            

            

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}